import {
  createApp,
} from 'vue'
import { router } from '../../router'
import { setupGlobalComponents } from './global-components'
import { globalFilters } from './global-filters'
import { setupGlobalMixins } from './global-mixins'
import { setupSentry } from './sentry'
import { setupVitePreloadErrorReload } from './vite-preload-error'

export function setupApp() {
  if (document.querySelector('#spark-app')) {
    setupVitePreloadErrorReload()

    const app = createApp({})

    app.config.globalProperties.$filters = globalFilters
    app.config.globalProperties.user = Spark.state.user
    app.config.globalProperties.currentTeam = Spark.state.currentTeam

    setupGlobalComponents(app)
    setupGlobalMixins(app)

    setupSentry(app, router)

    app.use(router)

    app.mount('#spark-app')

    window.app = app

    return app
  }
}
